<div class="relative">
  <mat-form-field class="absolute h-0 overflow-hidden" appearance="fill">
    <mat-label>{{ 'Language Picker.Label' | translate }}</mat-label>
    <mat-select #select [formControl]="languageControl">
      @for (language of languages; track $index) {
        <mat-option [value]="language.locale">{{ language.name }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <button immoIconButton [theme]="theme()" [size]="size()" [outlined]="outlined()" icon="translate" (click)="select.open()"></button>
</div>
